// extracted by mini-css-extract-plugin
export default {"ContractParties":"_ContractParties--FWVe_","NoCounterparties":"_NoCounterparties--rQcRP","CounterpartyName":"_CounterpartyName--xgPEJ","MoreParties":"_MoreParties--wRgms"};